import { makeStyles } from '@material-ui/core'

export const useAuditLogItemStyles = makeStyles((theme) => ({
  auditIcon: {
    width: 24,
    height: 32,
  },
}))
